export const UPDATED_CUSTOMER_FORM_VALIDATION_STATE =
  "UPDATED_CUSTOMER_FORM_VALIDATION_STATE";

export function updateCustomerFormValidationState(validationIsGood) {
  return function(dispatch) {
    return dispatch({
      type: UPDATED_CUSTOMER_FORM_VALIDATION_STATE,
      data: validationIsGood
    });
  };
}
